/**
 * Promotion Loader
 * Parses the global active promotions data and validates scheduling windows.
 */
class LcPromotionLoader {
  /**
   * Load active scheduled promotions.
   * @returns {Array<object>}
   */
  static load() {
    const dataEl = document.getElementById('LcPromotionsData');
    if (!dataEl) {
      console.warn('Promotion Loader - Promotions data element not found.');
      return [];
    }

    try {
      const promotions = JSON.parse(dataEl.textContent);
      
      // Filter out draft/inactive or unscheduled promotions
      const activePromos = promotions.filter(promo => {
        const isStatusActive = promo.status && promo.status.toLowerCase() === 'active';
        const isTimeActive = LcPromotionUtils.isScheduledActive(promo.scheduleStart, promo.scheduleEnd);
        return isStatusActive && isTimeActive;
      });

      // Sort by priority (highest priority first)
      activePromos.sort((a, b) => (b.priority || 0) - (a.priority || 0));

      return activePromos;
    } catch (e) {
      console.error('Promotion Loader - Failed to parse promotions data:', e);
      return [];
    }
  }
}

window.LcPromotionLoader = LcPromotionLoader;
